const FIRST_USER_CLIENT: string = '/First';
const USERS: string = '/Users';
export const USER_ID: string = ':userId';
const CLIENTS: string = '/Clients';
export const CLIENT_ID: string = ':clientId';
const SITES: string = '/Sites';
export const SITE_ID: string = ':siteId';
const SECTORS: string = '/Sectors';
export const SECTOR_ID: string = ':sectorId';
const ABILITIES: string = '/Abilities';
export const ABILITY_ID: string = ':abilityId';
const SKILLS: string = '/Skills';
export const SKILL_ID: string = ':skillId';
const EQUIPMENTS: string = '/Equipments';
export const EQUIPMENT_ID: string = ':equipmentId';

const DRIVE: string = '/Drive';

const CREATE_SUFFIX = '/Create';


export const ROUTES = {
  HOME: '/',
  FIRST_USER_CLIENT: FIRST_USER_CLIENT,
  CLIENTS: CLIENTS,
  CLIENT: CLIENTS + '/' + CLIENT_ID,
  NEW_CLIENT: CLIENTS + CREATE_SUFFIX,
  SITES: SITES,
  SITE: SITES + '/' + SITE_ID,
  NEW_SITE: SITES + CREATE_SUFFIX,
  SECTORS: SECTORS,
  SECTOR: SECTORS + '/' + SECTOR_ID,
  NEW_SECTOR: SECTORS + CREATE_SUFFIX,
  USERS: USERS,
  USER: USERS + '/' + USER_ID,
  NEW_USER: USERS + CREATE_SUFFIX,
  ABILITIES: ABILITIES,
  ABILITY: ABILITIES + '/' + ABILITY_ID,
  NEW_ABILITY: ABILITIES + CREATE_SUFFIX,
  SKILLS: SKILLS,
  SKILL: SKILLS + '/' + SKILL_ID,
  NEW_SKILL: SKILLS + CREATE_SUFFIX,
  EQUIPMENTS: EQUIPMENTS,
  EQUIPMENT: EQUIPMENTS + '/' + EQUIPMENT_ID,
  NEW_EQUIPMENT: EQUIPMENTS + CREATE_SUFFIX,
  DRIVE: DRIVE,
};